import TableHeaderCellDefault, { TableHeaderCellDefaultProps } from './Default';
import TableHeaderCellWrapper, { TableHeaderCellWrapperProps } from './Wrapper';

export type { TableHeaderCellDefaultProps, TableHeaderCellWrapperProps };
export { TableHeaderCellWrapper };
export default {
	Default: TableHeaderCellDefault
};
